import {State} from '@gongxigames/framework/slotV2/fsm/State';
import {consoleLogger} from '@gongxigames/framework/core';

export class UIState extends State {
    protected logActivation(): void {
        consoleLogger.log(`Run UIStates ===> ${this.name}`);
    }
}